import MoreArrow from "../../Helper/MoreArrow";
import moreArrow from "../../../constants/moreArrow";

const LatestNewsCard = ({ imgScr, author, date, heading, text }) => {
  return (
    <div className="w-11/12 h-5/6">
        <img src={imgScr} alt="News" className="w-full h-3/6 rounded-lg border" />
        <div className="w-full flex items-center justify-between text-gray-500 text-xs mt-2">
            <p>{author}</p>
            <p>{date}</p>
        </div>
        <h3 className="font-bold text-xl text-[#333333] mt-5 mb-3 2xl:text-2xl w-10/12">
            {heading}
        </h3>
        <p className="text-sm text-[#333333] 2xl:text-md">
            {text}
        </p>
        <MoreArrow text={moreArrow.TEXT_READ_MORE} />
    </div>
  )
}

export default LatestNewsCard